import { isEmpty, isBlank, isNull } from "../utils/common/utils";

export function calculateCCFBadges(headingData, originalHeadings, screenData, screenDataOriginal, columnIndex) {
    if (isEmpty(headingData) || isEmpty(screenData)) return headingData;
 
    return headingData.map( (heading, index) => {
      if (heading.CCF !== null && (columnIndex === null)) {
        const newHeading = Object.assign({}, heading);
        let previousValue = !isNull(headingData[index].PREVIOUS_VALUE) ? Number(headingData[index].PREVIOUS_VALUE) : null ;

        newHeading.CCFLABEL = calculateCCFBadge(newHeading, originalHeadings, screenData, screenDataOriginal, previousValue);

        return newHeading;
      }
      else {
        return heading;
      }
    });
  }

  export function calculateCCFBadge(heading, originalHeadings, screenData, screenDataOriginal, previousValue) {
    let existingCCF = heading.CCFS;

    let result = "";
    let lastValue = previousValue;

    if (existingCCF) result = "Ongoing CCF";

    for(const row of screenData) {
      const value = !isBlank(row[heading.CODE]) ? Number(row[heading.CODE]) : null;

      if (!isBlank(value)) {
        if (valueHasChanged(row, heading.CODE, screenDataOriginal)) {
          if (transitionOkToBad(heading, value, lastValue)) {
            result = "New CCF";
          }

          if (existingCCF && transitionBadToOk(heading, value, lastValue)) {
            if (result === "Ongoing CCF") result = "Pending Close";
          }
        }

        lastValue = value;
      }
    }

    const originalHeading = originalHeadings.find(h => h.CODE === heading.CODE);

    return !isBlank(result) && originalHeading
     ? result
     : originalHeading && originalHeading.CCFLABEL
      ? originalHeading.CCFLABEL
      : '';
  }

  function valueHasChanged(row, code, originalData) {
    if (originalData) {
      for(const originalRow of originalData) {
        if (originalRow.FTR_DATE === row.FTR_DATE && originalRow.FTR_HOUR === row.FTR_HOUR) {
          const originalValue = originalRow[code];
          const currentValue = row[code];
          var hasChanged = false;

          if (originalValue === null && currentValue !== null) hasChanged = true;
          else if (Number(originalValue) !== Number(currentValue)) hasChanged = true;
          return hasChanged;
        }
      }
    }

    return false;
  }

  export function formatCCF(heading, row, screenDataOriginal) {
    const value = row[heading.CODE];

    if (isBlank(value) || heading.CCF === null) return false;

    return !WithinTrigger(heading, Number(value));
  }

  function transitionOkToBad(heading, rowValue, lastRowValue) {
    if (isBlank(rowValue)) return false;

    if (!WithinAbsolute(heading, rowValue)) return true;

    return (!WithinTrigger(heading, lastRowValue) && !WithinTrigger(heading, rowValue));
  }

  function transitionBadToOk(heading, rowValue, lastRowValue) {
    if (isBlank(rowValue)) return false;

    return WithinTrigger(heading, rowValue);
  }

  function WithinTrigger(heading, value) {
    if (isNull(value)) return true;

    let lt = true;
    let ht = true;

    if (heading.LOWTRG !== null) {
      lt = value > heading.LOWTRG;
    }

    if (heading.HIGHTRG) {
      ht = value < heading.HIGHTRG;
    }

    return lt && ht;
  }

  function WithinAbsolute(heading, value) {
    if (isNull(value)) return true;

    let lt = true;
    let ht = true;

    if (heading.LOWABS !== null) {
      lt = value > heading.LOWABS;
    }

    if (heading.HIGHABS) {
      ht = value < heading.HIGHABS;
    }

    return lt && ht;
  }
